var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("van-search", {
        staticClass: "fixed width-99 z-99",
        attrs: { clearable: "", shape: "round", "show-action": "" },
        on: { search: _vm.onSearch },
        scopedSlots: _vm._u([
          {
            key: "action",
            fn: function () {
              return [
                _c(
                  "div",
                  {
                    staticClass:
                      "w-110 h-52 l-h-52 bg-FFDA3E b-r-28 text-center",
                    on: { click: _vm.onSearch },
                  },
                  [_vm._v("搜索")]
                ),
              ]
            },
            proxy: true,
          },
        ]),
        model: {
          value: _vm.queryParams.title,
          callback: function ($$v) {
            _vm.$set(_vm.queryParams, "title", $$v)
          },
          expression: "queryParams.title",
        },
      }),
      _c("div", { staticClass: "h-110" }),
      _c(
        "van-pull-refresh",
        {
          on: { refresh: _vm.onRefresh },
          model: {
            value: _vm.refreshing,
            callback: function ($$v) {
              _vm.refreshing = $$v
            },
            expression: "refreshing",
          },
        },
        [
          _c(
            "van-list",
            {
              staticClass: "p-l-20 p-r-20 p-b-20",
              attrs: {
                "immediate-check": false,
                error: _vm.error,
                finished: _vm.finished,
                "finished-text": "没有更多了",
              },
              on: {
                "update:error": function ($event) {
                  _vm.error = $event
                },
                load: _vm.getList,
              },
              model: {
                value: _vm.loading,
                callback: function ($$v) {
                  _vm.loading = $$v
                },
                expression: "loading",
              },
            },
            _vm._l(_vm.list, function (item, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass: "bg-FF p-20 m-t-20",
                  on: {
                    click: function ($event) {
                      return _vm.change(item)
                    },
                  },
                },
                [
                  _c("div", { staticClass: "flex col-center row-between" }, [
                    _c("img", {
                      staticClass: "w-52 h-52",
                      attrs: {
                        src: `${_vm.image_base_url}/zhengxuanlist_icon.png`,
                      },
                    }),
                    _c(
                      "div",
                      {
                        staticClass:
                          "flex-1 font-30 cor-3E3A39 font-weight-600 m-l-10",
                      },
                      [_vm._v(" " + _vm._s(item.title) + " ")]
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "font-26 bg-FFFAEC cor-F8B91A p-l-10 p-r-10 p-b-6 p-t-6 border-7",
                      },
                      [_vm._v(" " + _vm._s(item.businessStatusName) + " ")]
                    ),
                  ]),
                  _c(
                    "van-row",
                    {
                      staticClass: "m-t-30",
                      attrs: { type: "flex", align: "center" },
                    },
                    [
                      _c("van-col", { attrs: { span: "10" } }, [
                        _c("div", { staticClass: "cor-88 font-30" }, [
                          _vm._v("申请时间"),
                        ]),
                      ]),
                      _c("van-col", { attrs: { span: "14" } }, [
                        _c("div", { staticClass: "cor-33 font-30" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm
                                  .moment(item.businessData.sqrq)
                                  .format("YYYY-MM-DD HH:mm")
                              ) +
                              " "
                          ),
                        ]),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "van-row",
                    {
                      staticClass: "m-t-10",
                      attrs: { type: "flex", align: "center" },
                    },
                    [
                      _c("van-col", { attrs: { span: "10" } }, [
                        _c("div", { staticClass: "cor-88 font-30" }, [
                          _vm._v("用餐日期"),
                        ]),
                      ]),
                      _c("van-col", { attrs: { span: "14" } }, [
                        _c("div", { staticClass: "cor-33 font-30" }, [
                          _vm._v(" " + _vm._s(item.businessData.ycrq) + " "),
                        ]),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "van-row",
                    {
                      staticClass: "m-t-10",
                      attrs: { type: "flex", align: "center" },
                    },
                    [
                      _c("van-col", { attrs: { span: "10" } }, [
                        _c("div", { staticClass: "cor-88 font-30" }, [
                          _vm._v("用餐时间"),
                        ]),
                      ]),
                      _c("van-col", { attrs: { span: "14" } }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "cor-33 font-30 van-multi-ellipsis--l3",
                          },
                          [_vm._v(" " + _vm._s(item.businessData.yclx) + " ")]
                        ),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "van-row",
                    {
                      staticClass: "m-t-10",
                      attrs: { type: "flex", align: "center" },
                    },
                    [
                      _c("van-col", { attrs: { span: "10" } }, [
                        _c("div", { staticClass: "cor-88 font-30" }, [
                          _vm._v("事由"),
                        ]),
                      ]),
                      _c("van-col", { attrs: { span: "14" } }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "cor-33 font-30 van-multi-ellipsis--l3",
                          },
                          [_vm._v(" " + _vm._s(item.businessData.sy) + " ")]
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              )
            }),
            0
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }